export const TYPES = {
  SET_LAYOUT_BEHAVIORS: "SET_LAYOUT_BEHAVIORS",
};

export function setLayoutBehaviors(layoutBehaviors) {
  return {
    type: TYPES.SET_LAYOUT_BEHAVIORS,
    layoutBehaviors,
  };
}
